module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/masters/master-menu/master-menu.component.css
// module id = ./src/app/masters/master-menu/master-menu.component.css
// module chunks = main